import ProgramAccessTable, { ProgramAccessTable as UnwrappedProgramAccessTable } from './ProgramAccessTable';

export default ProgramAccessTable;

export { UnwrappedProgramAccessTable };
